module.exports = __webpack_public_path__ + "img/construction-robot.79c42724.png";